<template>
  <div v-if="isExternalLink">
    <a
      v-tooltip="uniToolTipTranslation(name, 'en-US')"
      :href="state.path"
      :class="classList"
      :style="{ color: coloreTesto }"
    >
      <i :class="icon" :style="{ color: coloreSimboli }"></i>
      {{ uniTranslation(name) }}
      <b-badge v-if="badge && badge.text" :variant="badge.variant">{{ badge.text }}</b-badge>
    </a>
  </div>
  <div v-else>
    <div v-if="isProjectLink" @contextmenu.prevent="$refs.menu.open">
      <router-link :to="state" :class="classList">
        <div :style="{ color: coloreTesto }">
          <i :class="icon" :style="{ color: coloreSimboli }"></i>
          {{ name }}
          <b-badge v-if="badge && badge.text" :variant="badge.variant">{{ badge.text }}</b-badge>
        </div>
      </router-link>
      <VueContext ref="menu" style="color: #000">
        <ul>
          <li @click="onClick('open')">{{ uniTranslation("S236") }}</li>
          <li @click="onClick('close')">{{ uniTranslation("S648") }}</li>
        </ul>
      </VueContext>
    </div>
    <div v-else>
      <router-link
        v-tooltip="uniToolTipTranslation(name, 'en-US')"
        :to="state"
        :class="classList"
        :style="{ color: coloreTesto }"
      >
        <i :class="icon" :style="{ color: coloreSimboli }"></i>
        {{ uniTranslation(name) }}
        <b-badge v-if="badge && badge.text" :variant="badge.variant">{{ badge.text }}</b-badge>
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { VueContext } from "vue-context";
import colorsService from "../../services/backend/colorsService";

export default {
  name: "SidebarNavLink",
  components: {
    VueContext
  },
  props: {
    name: {
      type: String,
      default: ""
    },
    state: {
      type: Object,
      default: ""
    },
    icon: {
      type: String,
      default: ""
    },
    badge: {
      type: Object,
      default: () => {}
    },
    variant: {
      type: String,
      default: ""
    },
    classes: {
      type: String,
      default: ""
    },
    projectId: {
      type: String,
      default: ""
    },
    modality: {
      //type: String,
      default: ""
    }
  },
  data() {
    return {
      coloreTesto: "",
      coloreSimboli: ""
    };
  },
  computed: {
    ...mapGetters(["projects"]),
    classList() {
      return ["nav-link", this.linkVariant, ...this.itemClasses];
    },
    linkVariant() {
      return this.variant ? `nav-link-${this.variant}` : "";
    },
    itemClasses() {
      return this.classes ? this.classes.split(" ") : [];
    },
    isExternalLink() {
      if (this.state.path && this.state.path.substring(0, 4) === "http") {
        return true;
      } else {
        return false;
      }
    },
    isProjectLink() {
      if (this.projectId && this.projectId !== "") {
        return true;
      } else {
        return false;
      }
    }
  },
  mounted: function() {
    var that = this;
    //colorsService.getColoriSidebar().then(function(data) {
    var colorList = colorsService.getColoriSidebar();
    that.coloreTesto = colorList[1];
    that.coloreSimboli = colorList[4];
    //});
  },
  methods: {
    /**
     * Alert the text of the menu item that was clicked on.
     *
     * @param {string} text
     */
    onClick(text) {
      var that = this;
      if (text == "close") {
        if (that.$route.params.projectId == that.state.params.projectId) {
          that.$router.push("/", function() {
            that.$store.dispatch("removeProject", that.state.params.projectId);
          });
        } else {
          that.$store.dispatch("removeProject", that.state.params.projectId);
        }
        return;
      }
      if (text == "open") {
        this.$router.push(that.state);
        return;
      }
      //alert(`You clicked ${text}!`);
    }
  }
};

/*



      <!--<a href="http://"><i class="fa fa-window-close-o"></i></a>  style="max-width: 220px !important"  -->

<v-popover offset="16">

      <router-link 
        :to="state" 
        :class="classList"
        class="tooltip-target b3"> <!--  v-tooltip="'<a href=\'http://\'><i class=\'fa fa-window-close-o\'></i> Close</a>'" -->
          <i :class="icon"></i> {{uniTranslation(name)}}
          <b-badge v-if="badge && badge.text" :variant="badge.variant" >{{badge.text}}</b-badge>
      </router-link>

  <!-- This will be the popover target (for the events and position) -->
  

  <!-- This will be the content of the popover -->
  <template slot="popover">
    <input class="tooltip-content" v-model="msg" placeholder="Tooltip content" />
    <p>
      ciao
    </p>

    <!-- You can put other components too -->
    
  </template>
</v-popover>

        <!-- <b-link @click="preventDefault()">
          <b-badge v-if="badge && badge.text" :variant="badge.variant" >{{badge.text}}</b-badge>
        </b-link> -->

*/
</script>

<style>
.v-context {
  background: #fafafa;
  border: 1px solid #bdbdbd;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);
  display: block;
  margin: 0;
  padding: 0;
  position: fixed;
  width: 250px;
  z-index: 99999;
}
.v-context ul li {
  margin: 0;
  padding: 10px 35px;
  cursor: pointer;
}
.v-context ul li:hover {
  background: #1e88e5;
  color: white;
}
.v-context ul {
  list-style: none;
  padding: 10px 0;
  margin: 0;
  font-size: 12px;
  font-weight: 600;
  padding-top: 0;
  padding-bottom: 0;
}
</style>
